export default "__VITE_ASSET__BlBOuPhM__"